import PlatformWrapper from '../platform-wrapper';
import { Tabs } from '@drip/drip-design';
import IconTip from '@/components/icon-tip';
import { listType_string } from '@/pages/all-about-me/components/signed-activity/constants/list-type';
import ListContent from '@/pages/all-about-me/components/signed-activity/components/list-content';
import React, { useEffect, useState } from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import Container from '@/components/container';
import { message } from 'antd';
import apis from '@/apis/generic/mac/square';
import './index.less';

function ActivitySignUp(props: any) {
  const [queryType, setQueryType] = useState('');
  const [label, setLabel] = useState<any>({ marketSceneTags: [], activityTypeTags: [], benefitTags: [] });

  useEffect(() => {
    // 货主相关角色定位并选中某些参数
    let _queryType = listType_string.REPORTABLE_ACT;
    try {
      const params = window.sessionStorage.getItem('cargoOwnerParams');
      if (params) {
        _queryType = JSON.parse(params).queryType;
      }
    } catch (e) {
      console.error(e);
    }
    setQueryType(_queryType);
  }, []);

  // 标签数据
  useEffect(() => {
    apis
      .tags()
      .then((res) => {
        const { ret, data, msg } = res;
        if (ret != '0') throw msg || '标签数据请求失败';
        setLabel(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, []);

  return queryType ? (
    <PlatformWrapper title="活动报名" hasMore={false}>
      <ContextProviderMenus.Provider value={{ label: label }}>
        <Container
          margin={false}
          paddingSize="max"
          padding={{ bottom: false, top: false, left: false, right: false }}
          className="signed-activity-container"
        >
          <Tabs
            activeKey={queryType}
            onChange={(key) => {
              setQueryType(key);
              (window as any).log('yx_center', 'workbench_signuptab', JSON.stringify({ activitytab: key }));
            }}
          >
            <Tabs.TabPane
              key={listType_string.ALL_ACT}
              tab={
                <span>
                  全部活动
                  <IconTip
                    title="全部活动是您现阶段有机会参与的所有活动。"
                    arrowPointAtCenter
                    placement="bottomRight"
                  />
                </span>
              }
            />
            <Tabs.TabPane tab="可报活动" key={listType_string.REPORTABLE_ACT} />
            <Tabs.TabPane tab="已报活动" key={listType_string.REPORTED_ACT} />
            <Tabs.TabPane tab="收藏活动" key={listType_string.COLLECTION_ACT} />
          </Tabs>
          <a
            className="signed-activity-operation-guide-block"
            onClick={() => window.open('https://yx.jd.com/help/list/464')}
          >
            <div className="operation-guide-block-svg">
              <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.33252 0.997981L6.99919 1.68698L8.66585 0.997981C9.73575 0.555686 10.9293 0.555686 11.9992 0.997981L13.2468 1.51373C13.4999 1.61837 13.6659 1.87172 13.6659 2.15345V10.3153C13.6659 10.6958 13.3674 11.0043 12.9992 11.0043C12.9144 11.0043 12.8303 10.9875 12.7516 10.955L11.9992 10.6439C10.9293 10.2016 9.73575 10.2016 8.66585 10.6439L6.99919 11.3329L5.33252 10.6439C4.26262 10.2016 3.06909 10.2016 1.99919 10.6439L1.24678 10.955C0.904924 11.0963 0.516944 10.9244 0.380202 10.5711C0.348703 10.4898 0.33252 10.4029 0.33252 10.3153V2.15345C0.33252 1.87172 0.498487 1.61837 0.751592 1.51373L1.99919 0.997981C3.06909 0.555686 4.26262 0.555686 5.33252 0.997981ZM2.50857 2.23018L1.66585 2.57855V9.34233C3.01613 8.8356 4.50421 8.85873 5.84191 9.41173L6.33252 9.61426V2.85426L4.82313 2.23018C4.07943 1.92273 3.25227 1.92273 2.50857 2.23018ZM9.17524 2.23018L7.66585 2.85359V9.61426L8.15647 9.41173C9.49417 8.85873 10.9822 8.8356 12.3325 9.34233V2.57855L11.4898 2.23018C10.7461 1.92273 9.91894 1.92273 9.17524 2.23018Z"
                  fill="#2D64FF"
                />
              </svg>
            </div>
            <div className="operation-guide-block-text">操作指南</div>
          </a>
        </Container>
        <ListContent queryType={Number(queryType)} />
      </ContextProviderMenus.Provider>
    </PlatformWrapper>
  ) : null;
}

export default ActivitySignUp;
